import React, { Suspense, lazy } from 'react';
import { LoadingSpinner } from './LoadingSpinner';

/**
 * Higher-order component for lazy loading with loading states
 * Requirements: 11.1, 11.2
 */
export const withLazyLoading = <P extends object>(
  importFunc: () => Promise<{ default: React.ComponentType<P> }>,
  fallback?: React.ReactNode
) => {
  const LazyComponent = lazy(importFunc);
  
  return (props: P) => (
    <Suspense fallback={fallback || <LoadingSpinner />}>
      <LazyComponent {...props} />
    </Suspense>
  );
};

// Lazy load heavy components
export const LazyProgramCreator = withLazyLoading(
  () => import('./ProgramCreator'),
  <LoadingSpinner message="Загрузка создателя программ..." />
);

export const LazyWorkoutSession = withLazyLoading(
  () => import('./WorkoutSession'),
  <LoadingSpinner message="Загрузка тренировки..." />
);

export const LazyProgressDashboard = withLazyLoading(
  () => import('./ProgressDashboard'),
  <LoadingSpinner message="Загрузка аналитики..." />
);

export const LazyWorkoutHistoryManager = withLazyLoading(
  () => import('./WorkoutHistoryManager'),
  <LoadingSpinner message="Загрузка истории..." />
);

export const LazyExerciseSelector = withLazyLoading(
  () => import('./ExerciseSelector'),
  <LoadingSpinner message="Загрузка каталога упражнений..." />
);

export default withLazyLoading;